export * from './IconThumbDown';
